const TOKEN_STORAGE_KEY = "token";
const PERSISTENCE_STORAGE_KEY = "xima_auth_persistence";
const PERSISTENCE_LOCAL = "local";
const PERSISTENCE_SESSION = "session";

const getStorageByScope = (scope) => {
  if (typeof window === "undefined") return null;
  if (scope === PERSISTENCE_SESSION) return window.sessionStorage;
  return window.localStorage;
};

const readTokenFromStorage = (storageRef) => {
  if (!storageRef) return "";
  try {
    return String(storageRef.getItem(TOKEN_STORAGE_KEY) || "").trim();
  } catch (error) {
    return "";
  }
};

const clearTokenFromStorage = (storageRef) => {
  if (!storageRef) return;
  try {
    storageRef.removeItem(TOKEN_STORAGE_KEY);
  } catch (error) {
    // Ignore storage access errors.
  }
};

export const clearStoredAuthToken = () => {
  clearTokenFromStorage(getStorageByScope(PERSISTENCE_LOCAL));
  clearTokenFromStorage(getStorageByScope(PERSISTENCE_SESSION));
  const localStorageRef = getStorageByScope(PERSISTENCE_LOCAL);
  if (!localStorageRef) return;
  try {
    localStorageRef.removeItem(PERSISTENCE_STORAGE_KEY);
  } catch (error) {
    // Ignore storage access errors.
  }
};

export const getStoredAuthToken = () => {
  const localToken = readTokenFromStorage(getStorageByScope(PERSISTENCE_LOCAL));
  if (localToken) return localToken;
  return readTokenFromStorage(getStorageByScope(PERSISTENCE_SESSION));
};

export const storeAuthToken = (token, { persist = true } = {}) => {
  const normalizedToken = String(token || "").trim();
  clearStoredAuthToken();
  if (!normalizedToken) return "";

  const scope = persist ? PERSISTENCE_LOCAL : PERSISTENCE_SESSION;
  const targetStorage = getStorageByScope(scope);
  if (!targetStorage) return normalizedToken;

  try {
    targetStorage.setItem(TOKEN_STORAGE_KEY, normalizedToken);
    const localStorageRef = getStorageByScope(PERSISTENCE_LOCAL);
    if (localStorageRef) {
      localStorageRef.setItem(PERSISTENCE_STORAGE_KEY, scope);
    }
  } catch (error) {
    // Ignore storage access errors.
  }

  return normalizedToken;
};

